import { render } from "./InitialHoldModal.vue?vue&type=template&id=6d25196e&ts=true&lang=pug"
import script from "./InitialHoldModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InitialHoldModal.vue?vue&type=script&lang=ts&setup=true"

import "./InitialHoldModal.vue?vue&type=style&index=0&id=6d25196e&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__